import { FC } from 'react'
import Slider, { SliderProps } from 'rc-slider'
import '!style-loader!css-loader!rc-slider/assets/index.css'
import * as styles from 'components/features/pfm/InputRange/InputRange.styl'

const TRACK_STYLE = { height: 8, border: '1px solid #ced5df', backgroundColor: 'transparent' }
const HANDLE_STYLE = {
  border: '4px solid #3172f5',
  height: 24,
  width: 24,
  marginLeft: -12,
  marginTop: -8,
  boxShadow: '1px 1px 3px rgba(0, 0, 0, .15)',
}

type InputRangeProps =
  & SliderProps

export const InputRange: FC<InputRangeProps> = (props) => {
  const { trackStyle, handleStyle, railStyle, ...restProps } = props
  return (
    <div className={ styles.input }>
      <Slider
        trackStyle={ TRACK_STYLE }
        railStyle={ TRACK_STYLE }
        handleStyle={ HANDLE_STYLE }
        { ...restProps }
      />
    </div>
  )
}
